export default __webpack_public_path__ + "static/media/phone-page-info.eb3539b7.jpg";